import { IElementsProvider } from "./IElementsProvider";
import { ElementMenuItem } from '../elementMenuItem';
import { Product } from '@/store/modules/product';
import { ElementType, SpecyficType } from '../element';
import { Vector2 } from '@babylonjs/core';

class DeskElementsProvider implements IElementsProvider {

    get(product: Product): ElementMenuItem[] {
        return [
            new ElementMenuItem(
                'ikony_Szuflada_mala.svg',
                'deskShortDrawer',
                'b_s_1.gltf',
                '',
                'b_s_1_komora_light.jpg',
                new Vector2(1, 1),
                ElementType.INSIDE,
                SpecyficType.DRAWER,
            ),
            new ElementMenuItem(
                'ikony_Szuflada_duza.svg',
                'deskLongDrawer',
                'b_s_2.gltf',
                '',
                'b_s_2_komora_light.jpg',
                new Vector2(2, 1),
                ElementType.INSIDE,
                SpecyficType.DRAWER,
            ),
        ];
    }
}

export const deskElementsProvider = new DeskElementsProvider();
